import React from "react"
import * as Components from "../../components/components"
import { DateiAnlage } from "../../models/dateianlage"
import { NoState } from "../../models/interfaces"

interface DateiAnlageViewProps {
    index: number
    anlage: DateiAnlage
}

export class DateiAnlageView extends React.Component<DateiAnlageViewProps, NoState> {
    render() {
        const anlage = this.props.anlage
        return (
            <Components.Row>
                <Components.Col size={8}>
                    <div className="small">
                        <p key="2">
                            {anlage.dateiname} &ndash; {anlage.mimeType} &ndash; {anlage.groesse} Bytes
                        </p>
                    </div>
                </Components.Col>
            </Components.Row>
        )
    }
}
